<template>
  <div class="bbs">
    <h3>{{ $t('bbsForm.title') }}</h3>
    <div class="bbsList">
      <ul>
        <li :key="item.BBS_NO" v-for="item in bbsList" @click="showBssDetail(item.BBS_NO)">
          <a>{{item.BBS_TITLE}}</a>
          <span>{{ dateFilter(item.REGDT, '.') }}</span>
        </li>
      </ul>
    </div>
    <modal ref="bssDetail" id="bssDetail" :closable="true">
      <template v-slot:header>
        {{ $t('bbsForm.title') }}
      </template>
      <bbs-detail :bbs-no="bbsNo"/>
    </modal>
  </div>
</template>
<script>
import { dateFilter } from '@/utils/filter'
import { getBBSList } from '@/api/bbs'
import Modal from '@/components/Modal.vue'
import bbsDetail from '@/components/BBS/BBSDetail.vue'

export default {
  name: 'BBS',
  components: {
    Modal,
    bbsDetail,
  },
  data: () => ({
    bbsNo: null,
    isShowDetail: false,
    bbsList: [],
  }),
  methods: {
    dateFilter,
    showBssDetail(bbsNo){
      this.bbsNo = bbsNo;
      this.$refs.bssDetail.show();
    },
  },
  mounted(){
    getBBSList().then((e) => {
      if(e.status === 200){
        this.bbsList = e.data;
      } else {
        this.bbsList = [];
      }
    })
  },
};
</script>
<style lang="scss" scoped>
  .bbs {
    > h3 {
      font-size: 20px;
      font-weight: 500;
    }

    .bbsList {
      width: 100%;
      margin-top: 20px;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        width: 8px;
      }
      &::-webkit-scrollbar-button {
        &start:decrement, &end:increment{
          display: block; width: 8px; height: 0px; background: none;
        }
      }
      &::-webkit-scrollbar-track {
        background: none;
      }
      &::-webkit-scrollbar-thumb {
        background: rgba(150, 150, 150, 0.5);
      }
      &::-webkit-scrollbar-thumb {
        background: rgba(150, 150, 150, 0.5);
        &:hover {
          background: rgba(150, 150, 150, 0.7);
        }
      }
      > ul > li {
        width: 100%;
        height: 34px;
        line-height: 34px;
        background-color: #f5f6f8;
        display: flex;
        padding-left: 20px;
        border-bottom: 1px dotted #999;
        background-image: url('~@/assets/image/list.png'); background-repeat: no-repeat;

        &:hover {
          > a, > span {
            color: #1454bf;
          }
        }
        > a {
          width: 70%;
          height: inherit;
          font-size: 12px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
        }
        > span {
          width: 30%;
          height: inherit;
          font-size: 12px;
          color: #999;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }

</style>
